import { lazy } from 'react';

export { AutoAttendantWizard } from '@/capabilities/microsoft-365-management/routes';

// M365 Intune Proactive Remediations
export const IntuneAppApprovalsPage = lazy(() =>
  import('@/capabilities/microsoft-365-management/pages/m365/IntuneAppApprovalsPage').then((m) => ({
    default: m.IntuneAppApprovalsPage,
  }))
);

export const PowerAutomateInventoryPage = lazy(() =>
  import('@/capabilities/microsoft-365-management/pages/m365/PowerAutomateInventoryPage').then(
    (m) => ({ default: m.PowerAutomateInventoryPage })
  )
);

export const IntuneRemediationsPage = lazy(() =>
  import('@/capabilities/microsoft-365-management/pages/m365/IntuneRemediationsPage').then((m) => ({
    default: m.IntuneRemediationsPage,
  }))
);

export const IntuneEnrollmentPosturePage = lazy(() =>
  import('@/capabilities/microsoft-365-management/pages/m365/IntuneEnrollmentPosturePage').then(
    (m) => ({ default: m.IntuneEnrollmentPosturePage })
  )
);

// Microsoft 365 (Calendar & Email)
export const SecureScore = lazy(() =>
  import('@/capabilities/microsoft-365-management/pages/m365/SecureScore').then((m) => ({
    default: m.SecureScore,
  }))
);

export const UsageAnalytics = lazy(() =>
  import('@/capabilities/microsoft-365-management/pages/m365/UsageAnalytics').then((m) => ({
    default: m.UsageAnalytics,
  }))
);

export const InactiveUsers = lazy(() =>
  import('@/capabilities/microsoft-365-management/pages/m365/InactiveUsers').then((m) => ({
    default: m.InactiveUsers,
  }))
);

export const SignInLogs = lazy(() =>
  import('@/capabilities/microsoft-365-management/pages/m365/SignInLogs').then((m) => ({
    default: m.SignInLogs,
  }))
);

export const RiskyAgents = lazy(() =>
  import('@/capabilities/microsoft-365-management/pages/m365/RiskyAgents').then((m) => ({
    default: m.RiskyAgents,
  }))
);
